export interface FontFamilyOption {
  label: string;
  /** The family name as stored, unquoted; the format quotes it for CSS. */
  value: string;
  /** Brand-kit face rather than a system family. */
  isCustom?: boolean;
}

/**
 * Brand faces lead; the system list is long enough to push them below the
 * dropdown's scroll view. Stable — each group keeps its incoming order.
 */
export function partitionBrandFonts<T extends { isCustom?: boolean }>(
  options: readonly T[],
): { brand: T[]; system: T[] } {
  return {
    brand: options.filter((option) => option.isCustom),
    system: options.filter((option) => !option.isCustom),
  };
}
